import React from "react";
import menuBar from "../../../../assets/images/menu-bar.png";
import Logo from "../../../../assets/images/ALISOUQ-LOGO.png";
import like from "../../../../assets/images/like.svg";
import bag from "../../../../assets/images/bag.svg";
import { connect } from "react-redux";
import { Link } from "react-router-dom";

function Header(props) {
  return (
    <div>
      <div
        style={{
          display: "flex",
          alignItems: "center",
          padding: "0px 23px 0px 31px",
          justifyContent: "space-between",
        }}
      >
        <div>
          <Link
            style={{
              textDecoration: "none",
            }}
            to={"/" + props.countryUrl + "-" + props.lang + "/sidebar"}
          >
            <img src={menuBar} alt="menu bar" />
          </Link>
        </div>
        <div style={{ margin: "19px 0px 13px 24px" }}>
          <a href={"/" + props.countryUrl + "-" + props.language}>
            <img src={Logo} alt="" height={36} />
          </a>
        </div>
        <div style={{ display: "flex", gap: "19px" }}>
          <Link
            style={{
              textDecoration: "none",
            }}
            to={"/" + props.countryUrl + "-" + props.lang + "/wishlist"}
          >
            <img src={like} alt="like" />
          </Link>
          <Link
            style={{
              textDecoration: "none",
            }}
            to={"/" + props.countryUrl + "-" + props.lang + "/cart"}
          >
            <img src={bag} alt="bag" height={20} />
          </Link>
        </div>
      </div>
      <div className="divider" />
    </div>
  );
}

const mapStateToProps = (state) => {
  return {
    language: state.language.language,
    countryUrl: state.language.countryUrl,
    lang: state.language.language,
    // country: state.language.country,
    // countryId: state.language.countryId,
    // coutriesList: state.language.coutriesList,
    // categories: state.header.allCategories,
    // featuredCategories: state.header.featuredCategories,
    // width: state.layout.screenWidth,
    // user: state.auth.user,
    // cart_items: state.cart.cart_items,
    // cart_items_length: state.cart.cart_items_length,
    // notifications_count: state.notifications.count,
  };
};

const mapDispatchToProps = {
  //   set_country,
  //   set_categories,
  //   set_search,
  //   set_direction,
  //   set_cart_items,
  //   set_user,
};

export default connect(mapStateToProps, mapDispatchToProps)(Header);
